import {
  RESET_REPORTS,
  GET_REPORTS_STARTED,
  GET_REPORTS_SUCCESS,
  GET_REPORTS_FAILURE,
} from "../constants/auth.constant";

const initialState = {
  loading: false,
  list: [],
  error: null,
};

export default function getAllNewReportsReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_REPORTS:
      return {
        ...state,
        loading: false,
        list: [],
        error: null,
      };
    case GET_REPORTS_STARTED:
      return {
        ...state,
        loading: true,
      };
    case GET_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        list: action.payload,
      };
    case GET_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
